module.exports = __webpack_public_path__ + "img/logo.a51a38ea.svg";